import { createSelector } from '@reduxjs/toolkit';

import Opportunity from '../../static/models/Opportunity';
import { RootState } from '../root';

export const selectOpportunity = (state: RootState): Opportunity => state.opportunity;

export const selectOpportunityId = createSelector(selectOpportunity, o => o.opportunityId);
export const selectOpportunityCustomerPaths = createSelector(selectOpportunity, o => o.parsedCustomerPath || []);
